module.exports = __webpack_public_path__ + "img/icon-post-typing.9491106.svg";